import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5736c414"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "userManage" }

import qs from 'qs';
import { ref, reactive, } from 'vue';
import { useStore, } from 'vuex';
import { useRouter, useRoute, } from 'vue-router';
import { Button, Input, } from 'ant-design-vue';

import Sider from '../../components/sider/index.vue';
import Table from './components/table/index.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const selectedKey = ref<any>('');
const level = ref<any>('');

const getKeyAndLevel = (item: any) => {
  selectedKey.value = item?.selectedKey[0];
  level.value = item?.level;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Sider, {
      pageType: "user",
      onGetKey: getKeyAndLevel
    }),
    _createVNode(Table, {
      "selected-key": selectedKey.value,
      "selected-level": level.value
    }, null, 8, ["selected-key", "selected-level"])
  ]))
}
}

})